import { memo } from "react";

import InputText from "@/design/forms/InputText";

import PropTypes from "prop-types";

const InputPhone = ({ onChange, value, specialChars, ...props }) => {
  const preventDefaultChange = (id, _value) => {
    onChange(id, checkFormat(_value) ? _value : value);
  };

  const checkFormat = (value) => {
    const regex = specialChars ? new RegExp("^[+*#]{0,1}[0-9*]{0,21}$") : new RegExp("^[+]{0,1}[0-9]{0,21}$");
    return regex.test(value);
  };

  return <InputText {...props} type="tel" onChange={preventDefaultChange} value={value} />;
};

InputPhone.default = {
  specialChars: false,
};

InputPhone.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  specialChars: PropTypes.bool,
  id: PropTypes.string,
};

export default memo(InputPhone);
